import { AppBar, Toolbar, Container, Button, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuthStore } from '../store/authStore';
import VKAuth from './VKAuth';
import logo from '../assets/logo-square.png';

export default function Header() {
  const { user, isAuthenticated, logout } = useAuthStore();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMobileMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileClose = () => {
    setMobileMenuAnchor(null);
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1 }}>
          <Box
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              flexGrow: { xs: 1, md: 0 },
              mr: 4,
              transition: 'all 0.3s ease',
              '&:hover': {
                opacity: 0.9,
              },
            }}
          >
            <img
              src={logo}
              alt="СПЕКТУМ"
              style={{
                height: '40px',
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Desktop Menu */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, gap: 2 }}>
            <Button
              component={Link}
              to="/"
              sx={{
                color: 'white',
                fontWeight: 500,
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
              }}
            >
              Главная
            </Button>
            <Button
              component={Link}
              to="/events"
              sx={{
                color: 'white',
                fontWeight: 500,
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
              }}
            >
              Мероприятия
            </Button>
            <Button
              component={Link}
              to="/news"
              sx={{
                color: 'white',
                fontWeight: 500,
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
              }}
            >
              Новости
            </Button>
          </Box>

          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton onClick={handleMobileMenu} sx={{ color: 'white' }}>
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={mobileMenuAnchor}
              open={Boolean(mobileMenuAnchor)}
              onClose={handleMobileClose}
            >
              <MenuItem component={Link} to="/" onClick={handleMobileClose}>
                Главная
              </MenuItem>
              <MenuItem component={Link} to="/events" onClick={handleMobileClose}>
                Мероприятия
              </MenuItem>
              <MenuItem component={Link} to="/news" onClick={handleMobileClose}>
                Новости
              </MenuItem>
            </Menu>
          </Box>

          {/* Auth Section */}
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {isAuthenticated && user ? (
              <>
                <IconButton
                  onClick={handleMenu}
                  sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.2)',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.3)' },
                  }}
                >
                  {user.avatar ? (
                    <img
                      src={user.avatar}
                      alt={user.firstName}
                      style={{ width: 32, height: 32, borderRadius: '50%' }}
                    />
                  ) : (
                    <AccountCircleIcon sx={{ color: 'white' }} />
                  )}
                </IconButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                  <MenuItem
                    onClick={() => {
                      navigate('/profile');
                      handleClose();
                    }}
                  >
                    Профиль
                  </MenuItem>
                  {user.role === 'admin' && (
                    <MenuItem
                      onClick={() => {
                        navigate('/admin');
                        handleClose();
                      }}
                    >
                      Администрирование
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => {
                      logout();
                      handleClose();
                    }}
                  >
                    Выйти
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <VKAuth 
                onSuccess={() => {
                  console.log('VK Auth успешна');
                }}
                onError={(error) => {
                  console.error('VK Auth ошибка:', error);
                }}
              />
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
